/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { makeStyles } from '@material-ui/core';
import ReactHTMLParser from 'react-html-parser';
import { useSelector } from 'react-redux';
import { getAddToCartError } from '../../../../state/ducks/Common/Common-Selectors';

const useStyles = makeStyles(() => ({
    container: {
        color: 'red',
        marginBottom: '10px',
    },
}));

const AddToCarErrorInline = () => {
    const errorMessage = useSelector(getAddToCartError);

    const classes = useStyles();
    if (errorMessage && typeof errorMessage === 'string') {
        return (
            <div className={classes.container}>
                {ReactHTMLParser(errorMessage)}
            </div>
        );
    }
    return null;
};

AddToCarErrorInline.propTypes = {};

export default AddToCarErrorInline;
